/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import ArticlesAction from "store/articles/ArticlesAction";
import {Article, ArticlePersonsType} from "types/entities";
import {PersonType} from "types/enums/PersonType";
import {ReducerResetAction} from "store/session/SessionReducer";
import SessionAction from "store/session/SessionAction";

interface ArticlesReducerSetArticlesAction {
    payload: Article[];
    type: typeof ArticlesAction.SET_ARTICLES;
}

interface ArticlesReducerSetArticlesKioskAction {
    payload: Article[];
    type: typeof ArticlesAction.SET_ARTICLES_KIOSK;
}

type ArticlesReducerAction = ArticlesReducerSetArticlesAction | ArticlesReducerSetArticlesKioskAction | ReducerResetAction;

export interface ArticlesReducerState {
    all: Article[] | null;
    online: ArticlePersonsType | null;
    action: ArticlePersonsType | null;
    vouchers: Article[] | null;
    articlesKiosk: Article[] | null;
}

class ArticlesReducer {
    initialState: ArticlesReducerState = {
        all: null,
        online: null,
        action: null,
        vouchers: null,
        articlesKiosk: null,
    };

    reducer = (state: ArticlesReducerState = this.initialState, action: ArticlesReducerAction): ArticlesReducerState => {
        switch (action.type) {
            case ArticlesAction.SET_ARTICLES:
                const onlineTickets = action.payload?.filter(article => article.type === "online");
                const actionTickets = action.payload?.filter(article => article.type === "action");
                const voucherTickets = action.payload?.filter(article => {
                    return article.type === "online" && article.ticket_type === "voucher";
                });

                if (!onlineTickets || !actionTickets || !voucherTickets) {
                    return state;
                }

                return {
                    ...state,
                    all: action.payload,
                    online: {
                        ...state.online,
                        adult: onlineTickets?.filter(article => article.person_type === PersonType.Adult),
                        child: onlineTickets?.filter(article => article.person_type === PersonType.Child),
                    },
                    action: {
                        ...state.action,
                        adult: actionTickets?.filter(article => article.person_type === PersonType.Adult),
                        child: actionTickets?.filter(article => article.person_type === PersonType.Child),
                    },
                    vouchers: voucherTickets,
                };
            case SessionAction.RESET:
                return this.initialState;
            case ArticlesAction.SET_ARTICLES_KIOSK:
                return {
                    ...state,
                    articlesKiosk: action.payload,
                };
            default:
                return state;
        }
    };
}

export default ArticlesReducer;
